import { UserMultipleIcon } from "@hugeicons-pro/core-stroke-rounded";
import { Section } from "views/applications-id-report/components/Section";
import { SectionIcon } from "../components/SectionIcon";
import { BorrowerCard } from "../components/BorrowerCard";
import { Borrower } from "../types";

export const BorrowersSlice = ({ borrowers }: { borrowers: Borrower[] }) => (
  <Section
    sectionTitle="Borrowers"
    icon={<SectionIcon icon={UserMultipleIcon} />}
  >
    <div className="space-y-4">
      {borrowers.map((borrower) => (
        <BorrowerCard key={borrower.email} borrower={borrower} />
      ))}
    </div>
  </Section>
);
